import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  .page {
    width: 720px;

    @media (max-width: 768px) {
      padding: 16px;
    }

    &.is-business {
      .stat.comparison {
        display: none;
      }

      .subscription-card {
        background: linear-gradient(20deg, rgb(0, 145, 255), rgb(13, 205, 253));
        color: #fff;
      }

      .limit-dotted-line {
        display: none;
      }

      .stat-progress-bar-track {
        overflow: hidden;

        .stat-progress-bar-fill {
          background: linear-gradient(20deg, hsl(208deg 18% 30%), hsl(208deg 18% 48%));
          max-width: 100%;
        }
      }
    }
  }

  .stats {
    width: 100%;
    background: ${({ theme }) => theme.white};
    padding: 16px;
    border-radius: 16px;
    gap: 50px;
    display: flex;
    flex-direction: column;
  }

  label {
    margin-bottom: 8px;
    display: block;
  }

  .section-wrapper {
    width: 100%;
    margin-bottom: 16px;

    @media (max-width: 768px) {
      label {
        margin-top: 0;
      }
    }
  }

  .orders-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;

    button {
      padding: 0;
      margin-top: 0;
      margin-bottom: 16px;
    }
  }

  .header {
    background: ${({ theme }) => theme.white};
    padding: 16px;
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
    border-radius: 16px;
    margin-bottom: 16px;

    .subscription-card {
      padding: 16px;
      border-radius: 16px;

      img {
        width: 32px;
        margin-bottom: 4px;
      }

      .brand-name {
        font-weight: 500;
        font-size: 14px;
      }

      .active-text {
        font-weight: 600;
        font-size: 25px;
        margin-bottom: -4px;
        letter-spacing: 0.7px;
      }
    }

    .price-and-button {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 1;
      gap: 16px;

      @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-end;
        padding-top: 14px;
        gap: 8px;
        text-align: right;
      }

      .subscription-price {
        font-weight: 600;
        font-size: 16px;

        .price-description {
          font-weight: 500;
          font-size: 13px;
        }

        .benefits-button {
          display: inline-block;
          margin-top: 4px;
          padding: 0;
          background: none;
          border: none;
          font-family: inherit;
          font-weight: 600;
          font-size: 13px;
          color: #11b7f3;
          cursor: pointer;
          text-decoration: underline;
          text-underline-offset: 3px;
          transition: opacity 0.15s ease;
        }

        .benefits-button:hover {
          opacity: 0.7;
        }
      }
    }

    .subscription-duration {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 8px;
      padding-bottom: 4px;

      .next-bill-date {
        text-align: right;
        display: block;
        font-size: 15px;

        &.red {
          color: ${props => props.theme.red};
          font-weight: 600;
        }

        &.blue {
          color: ${props => props.theme.accent};
        }
      }

      button {
        margin-bottom: -12px;
        padding: 0 20px;
      }
    }

    button {
      margin: 0;
      margin-right: 8px;
    }
  }

  .recurring-payment-info {
    background: ${({ theme }) => theme.white};
    padding: 16px;
    padding-top: 6px;
    border-radius: 16px;

    .info-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 0;
      border-bottom: 1px solid ${({ theme }) => theme.border};

      &:last-of-type {
        border-bottom: none;
      }

      .info-label {
        font-weight: 500;
        font-size: 14px;
        color: ${({ theme }) => theme.secondaryText};
      }

      .info-value {
        text-align: right;
        font-weight: 600;
        font-size: 14px;
        color: ${({ theme }) => theme.text};

        &.active {
          color: ${({ theme }) => theme.green};
        }

        &.inactive {
          color: ${({ theme }) => theme.red};
        }

        &.warning {
          color: ${({ theme }) => theme.red};
        }
      }
    }
  }
`
